<template>
  <div
    class="max-w-md bg-white dark:bg-stone-800 rounded-xl shadow-md overflow-hidden transform transition duration-300 hover:shadow-lg flex flex-col">
    <div class="px-6 pt-6 pb-2 flex-grow">
      <h3 class="text-2xl font-bold text-primary-600 dark:text-primary-400 mb-4">
        Get Started Now
      </h3>
      <div class="text-stone-700 dark:text-stone-300">
        <p class="mb-3">
          <strong>Ready to make random selection exciting?</strong> Spin the Names is completely free to use, with no
          registration required to get started.
        </p>
        <p class="mb-3">
          Simply add your entries, customize your wheel, and start spinning! Our advanced features include:
        </p>
        <ul class="space-y-2 mb-4 list-none">
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span>Save your wheels to use again later</span>
          </li>
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span>Share your wheel with a unique link</span>
          </li>
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span>Customize with colors, sounds, and animation effects</span>
          </li>
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span>Automatically remove or highlight winners</span>
          </li>
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span>Import names from spreadsheets</span>
          </li>
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span>Use on any device - mobile, tablet, or desktop</span>
          </li>
        </ul>
        <p class="text-center font-bold">
          Start spinning now and experience the most engaging random selector on the web!
        </p>
      </div>
    </div>
    <div class="h-1 bg-gradient-to-r from-primary-500 to-primary-400 flex-none"></div>
  </div>
</template>
